<div class="idp-confidence-details">
    <div class="d-flex justify-content-between align-items-center">
        <div
            class="d-flex confidence-level"
            [popover]="mappingExplanations.lowConfidenceReasons.length ? reasonTemplate : null"
            #reasonPopover="bs-popover"
            placement="top"
            [adaptivePosition]="true"
            container=".grid-page"
            triggers="mouseenter:mouseleave"
            style="border-radius: 24px"
            [class.low-confidence]="confidenceLevel === 'Low'"
        >
            <p style="margin: 0; padding: 5px 10px">
                @if (shouldShowItalicsLine) {
                    <span>IDP detected values are <em>italic</em> - </span>
                }
                <strong>Confidence Level: </strong> {{ confidenceLevel }}
            </p>
        </div>
        @if (canSeeDetails) {
            <button style="gap: 10px" class="ace-btn btn-secondary btn-sm" (click)="seeDetails()"> Details </button>
        }
        @if (!canSeeDetails) {
            <button class="ace-btn btn-primary has-icon m-0" (click)="reset()">
                <i class="fa fa-undo"></i>
            </button>
        }
    </div>
</div>

<ng-template #reasonTemplate>
    <ul>
        @for (reason of mappingExplanations.lowConfidenceReasons; track reason) {
            <li>
                {{ reason }}
            </li>
        }
    </ul>
</ng-template>
